console.log("BAZARTE JS CARGADO");

document.addEventListener("DOMContentLoaded", function () {

  console.log("BAZARTE: DOM listo");
  const compraValidada = localStorage.getItem("bazarte_has_purchase");

if (compraValidada === "1") {
  ya_compro = 1;
  console.log("BAZARTE: cliente con compra validada");
}

  const botonComenzar = document.getElementById("promoBtnClose");

  console.log("BAZARTE: promoBtnClose =", botonComenzar);

  if (!botonComenzar) {
    console.log("Bazarte: no se encontró promoBtnClose");
    return;
  }

  /*
   * Tomamos directamente el control del botón
   * COMENZAR AHORA.
   */
 botonComenzar.onclick = function (e) {

  e.preventDefault();
  e.stopPropagation();

  console.log("BAZARTE: botón COMENZAR AHORA detectado");

  // Cerrar el popup original
  // Cerrar directamente el popup original
const promoOverlay = document.getElementById("promoPopupOverlay");

if (promoOverlay) {
  promoOverlay.style.display = "none";
}

localStorage.setItem("promo_popup_closed", "yes");

// Abrir el popup para validar el correo
mostrarPopupCorreo();
  return false;
};


  window.mostrarPopupCorreo = function () {

    console.log("BAZARTE: abriendo popup de correo");

    if (document.getElementById("bazarteEmailPopup")) {
      document.getElementById("bazarteEmailPopup").style.display = "flex";
      return;
    }

    const popup = document.createElement("div");

    popup.id = "bazarteEmailPopup";

    popup.innerHTML = `
      <div class="bazarte-email-overlay" style="position:fixed; inset:0; z-index:999999; display:flex; align-items:center; justify-content:center;">

        <div class="bazarte-email-box">

          <button
            type="button"
            id="bazarteEmailClose"
            class="bazarte-email-close"
          >
            ×
          </button>

          <h3>Antes de continuar</h3>

          <p>
            Introduce tu correo electrónico para verificar si ya has realizado una compra.
          </p>

          <input
            type="email"
            id="bazarteCustomerEmail"
            placeholder="Tu correo electrónico"
            autocomplete="email"
          >

          <div
            id="bazarteEmailMessage"
            class="bazarte-email-message"
          ></div>

          <button
            type="button"
            id="bazarteValidateEmail"
            class="bazarte-email-button"
          >
            CONTINUAR
          </button>

        </div>

      </div>
    `;

    document.body.appendChild(popup);

    document.getElementById("bazarteEmailClose").onclick = function () {
      popup.remove();
    };

    document.getElementById("bazarteValidateEmail").onclick =
      validarCorreo;

    document.getElementById("bazarteCustomerEmail").focus();
  }


  async function validarCorreo() {

    const input = document.getElementById("bazarteCustomerEmail");
    const boton = document.getElementById("bazarteValidateEmail");
    const mensaje = document.getElementById("bazarteEmailMessage");

    const email = input.value.trim().toLowerCase();

    if (!email) {
      mensaje.textContent = "Escribe tu correo electrónico.";
      return;
    }

    if (!input.checkValidity()) {
      mensaje.textContent = "Introduce un correo electrónico válido.";
      return;
    }

    boton.disabled = true;
    boton.textContent = "VALIDANDO...";
    mensaje.textContent = "";

    try {

      const respuesta = await fetch(
        "/apps/customer-check?email=" + encodeURIComponent(email),
        {
          method: "GET",
          headers: {
            "Accept": "application/json"
          }
        }
      );

      if (!respuesta.ok) {
        throw new Error("Error HTTP " + respuesta.status);
      }

      const resultado = await respuesta.json();

      console.log("Bazarte Customer Validator:", resultado);

      if (
        resultado.success === true &&
        resultado.has_purchase === true
      ) {

        localStorage.setItem(
          "bazarte_customer_email",
          email
        );

        localStorage.setItem(
          "bazarte_has_purchase",
          "1"
        );
         ya_compro = 1;
         actualizarCheckoutBazarte();
         actualizarCheckoutPaginaCarritoBazarte();
         setTimeout(function () {
  actualizarCheckoutPaginaCarritoBazarte();
}, 300);

setTimeout(function () {
  actualizarCheckoutPaginaCarritoBazarte();
}, 800);

setTimeout(function () {
  actualizarCheckoutPaginaCarritoBazarte();
}, 1500);
        mensaje.textContent =
          "Correo validado. Ya tienes compras registradas.";

        setTimeout(function () {
          cerrarPopupValidacion();
        }, 800);

      } else {

        localStorage.setItem(
          "bazarte_customer_email",
          email
        );

        localStorage.setItem(
          "bazarte_has_purchase",
          "0"
        );

        mensaje.textContent =
          "No encontramos compras anteriores. Para clientes nuevos aplica el mínimo de $1,000 MXN.";

        boton.disabled = false;
        boton.textContent = "CONTINUAR";
      }

    } catch (error) {

      console.error(
        "Bazarte Customer Validator:",
        error
      );

      mensaje.textContent =
        "No pudimos validar el correo. Intenta nuevamente.";

      boton.disabled = false;
      boton.textContent = "CONTINUAR";
    }
  }


  function cerrarPopupValidacion() {

    const popup =
      document.getElementById("bazarteEmailPopup");

    if (popup) {
      popup.remove();
    }

    /*
     * Ahora sí cerramos el popup original.
     */
    /*if (typeof closePromoPopup === "function") {
      closePromoPopup();
    }*/
  }
});

document.addEventListener("click", function (e) {

  if (e.target.classList.contains("bazarte-validar-correo")) {

    console.log("BAZARTE: botón VALIDAR CORREO presionado");

    mostrarPopupCorreo();

  }

});

function agregarBotonValidarCorreo() {

  const contenedor =
    document.querySelector(".mini-cart__checkout_button");

  if (!contenedor) {
    return;
  }

  // Si el cliente ya tiene una compra validada,
  // quitamos las restricciones
  if (
    localStorage.getItem("bazarte_has_purchase") === "1"
  ) {
    actualizarCheckoutBazarte();
    return;
  }

  // Si ya existe el botón, no hacemos nada
  if (
    contenedor.querySelector(".bazarte-validar-correo")
  ) {
    return;
  }

  // Solo agregarlo si Comprar está bloqueado
  const botonComprar =
    contenedor.querySelector("a:not([href])");

  if (!botonComprar) {
    return;
  }

  const botonValidar =
    document.createElement("button");

  botonValidar.type = "button";
  botonValidar.className =
    "btn btn-fullwidth btn-style-1 bazarte-validar-correo";

  botonValidar.style.marginTop = "8px";
  botonValidar.textContent = "Validar correo";

  contenedor.appendChild(botonValidar);

  console.log(
    "BAZARTE: botón Validar correo agregado"
  );
}


// Revisar cuando la página termina de cargar
document.addEventListener(
  "DOMContentLoaded",
  function () {

    agregarBotonValidarCorreo();

    if (
      localStorage.getItem("bazarte_has_purchase") === "1"
    ) {

      console.log(
        "BAZARTE: validación existente detectada al cargar la página"
      );

      actualizarCheckoutPaginaCarritoBazarte();

      setTimeout(function () {
        actualizarCheckoutPaginaCarritoBazarte();
      }, 300);

      setTimeout(function () {
        actualizarCheckoutPaginaCarritoBazarte();
      }, 800);

      setTimeout(function () {
        actualizarCheckoutPaginaCarritoBazarte();
      }, 1500);
    }

  }
);

// Revisar cambios dinámicos del carrito
const observadorBazarte =
  new MutationObserver(function () {

    agregarBotonValidarCorreo();
    actualizarCheckoutBazarte();
    actualizarCheckoutPaginaCarritoBazarte();

  });

observadorBazarte.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);

function actualizarCheckoutBazarte() {

  const tieneCompra =
    localStorage.getItem("bazarte_has_purchase") === "1";

  if (!tieneCompra) {
    return;
  }

  const contenedor =
    document.querySelector(".mini-cart__checkout_button");

  if (!contenedor) {
    return;
  }

  console.log(
    "BAZARTE: cliente validado, quitando restricciones"
  );

  // Si ya existe el botón Comprar normal, no hacemos nada
  if (
    contenedor.querySelector('a[href="/checkout"]')
  ) {
    return;
  }

  // Crear nuevamente el botón Comprar
  contenedor.innerHTML =
    '<a href="/checkout" class="btn btn-fullwidth btn-style-1" id="mini-cart.checkout">Comprar</a>';

  console.log(
    "BAZARTE: botón Comprar desbloqueado"
  );
}

function actualizarCheckoutPaginaCarritoBazarte() {

  const tieneCompra =
    localStorage.getItem("bazarte_has_purchase") === "1";

  if (!tieneCompra) {
    return;
  }

  console.log(
    "BAZARTE: limpiando restricciones de la página del carrito"
  );

  // Buscar el botón actual, esté bloqueado o desbloqueado
  const botonActual =
    document.querySelector('[name="checkout"]');

  if (!botonActual) {
    return;
  }

  const contenedor =
    botonActual.parentElement;

  if (!contenedor) {
    return;
  }

  // 1. Eliminar el mensaje de compra mínima
  Array.from(contenedor.childNodes).forEach(function (nodo) {

    if (
      nodo.nodeType === Node.TEXT_NODE &&
      nodo.textContent.includes(
        "La cantidad minima para compra son $2000.00 MXN"
      )
    ) {
      nodo.remove();

      console.log(
        "BAZARTE: mensaje de compra mínima eliminado"
      );
    }

  });

  // 2. Eliminar botón Validar correo
  const botonValidar =
    contenedor.querySelector(".bazarte-validar-correo");

  if (botonValidar) {

    botonValidar.remove();

    console.log(
      "BAZARTE: botón Validar correo eliminado"
    );
  }

  // 3. Si el botón está bloqueado (DIV), convertirlo
  //    en un botón Comprar funcional
  if (botonActual.tagName === "DIV") {

    const botonCheckout =
      document.createElement("a");

    botonCheckout.href = "/checkout";
    botonCheckout.className =
      "btn btn-fullwidth btn-style-1";
    botonCheckout.setAttribute("name", "checkout");
    botonCheckout.textContent = "Comprar";

    botonActual.replaceWith(botonCheckout);

    console.log(
      "BAZARTE: botón Comprar desbloqueado"
    );
  }

}

/* =========================================================
   BAZARTE - VALIDACIÓN BOTÓN "COMPRAR AHORA"
   ========================================================= */

document.addEventListener("click", function (e) {

  const botonComprarAhora = e.target.closest(
    ".shopify-payment-button__button--unbranded"
  );

  if (!botonComprarAhora) {
    return;
  }

  console.log("BAZARTE: botón Comprar ahora detectado");

  const compraValidada =
    localStorage.getItem("bazarte_has_purchase");

  /*
   * Si el correo ya fue validado y tiene compras,
   * dejamos que Shopify continúe normalmente hacia checkout.
   */
  if (compraValidada === "1") {

    console.log(
      "BAZARTE: cliente validado, Comprar ahora permitido"
    );

    return;
  }

  /*
   * Si no está validado, detenemos completamente
   * el comportamiento de Shopify.
   */
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  console.log(
    "BAZARTE: Comprar ahora bloqueado, se requiere validar correo"
  );

  /*
   * Abrimos el mismo popup que ya utilizamos
   * para validar el correo.
   */
  if (typeof mostrarPopupCorreo === "function") {

    mostrarPopupCorreo();

  } else {

    console.error(
      "BAZARTE: mostrarPopupCorreo no está disponible"
    );

  }

}, true);